import { uid } from "@/lib/guideTemplate";
import { Plus, Trash2, Eye, EyeOff, ConciergeBell } from "lucide-react";

const SUGGESTIONS = ["Late check-out", "Early check-in", "Transfer aeroporto", "Culla", "Pulizia extra", "Colazione", "Deposito bagagli", "Noleggio bici"];

const inp = "w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500";

export function ExtrasEditor({ extras, onChange }) {
  const list = extras || [];
  const add = (title = "") => onChange([...list, { id: uid(), title, description: "", price: "", enabled: true }]);
  const upd = (id, patch) => onChange(list.map((e) => (e.id === id ? { ...e, ...patch } : e)));
  const del = (id) => onChange(list.filter((e) => e.id !== id));

  return (
    <div data-testid="extras-editor">
      <div className="flex items-center gap-2.5 mb-1">
        <div className="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 grid place-items-center shrink-0"><ConciergeBell className="w-4 h-4" /></div>
        <div><p className="font-semibold text-slate-800 text-sm">Extra e servizi</p><p className="text-[11px] text-slate-400 leading-tight">Servizi richiedibili dagli ospiti, con prezzo</p></div>
      </div>

      {list.length > 0 && (
        <div className="mt-3 space-y-3">
          {list.map((e) => (
            <div key={e.id} className="rounded-xl border border-slate-100 p-3 space-y-2" data-testid={`extra-${e.id}`}>
              <div className="flex items-center gap-2">
                <input className={inp + " font-semibold"} value={e.title} onChange={(ev) => upd(e.id, { title: ev.target.value })} placeholder="Nome servizio" data-testid={`extra-title-${e.id}`} />
                <button onClick={() => upd(e.id, { enabled: !(e.enabled ?? true) })} data-testid={`extra-toggle-${e.id}`} title="Mostra/nascondi" className={e.enabled ?? true ? "text-emerald-500" : "text-slate-300"}>{e.enabled ?? true ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}</button>
                <button onClick={() => del(e.id)} data-testid={`extra-delete-${e.id}`} className="text-slate-400 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
              </div>
              <textarea rows={2} className={inp + " resize-none"} value={e.description} onChange={(ev) => upd(e.id, { description: ev.target.value })} placeholder="Descrizione (facoltativa)" />
              <input className={inp} value={e.price} onChange={(ev) => upd(e.id, { price: ev.target.value })} placeholder="Prezzo (es. €20, Gratuito, Su richiesta)" data-testid={`extra-price-${e.id}`} />
            </div>
          ))}
        </div>
      )}

      <div className="mt-3 flex flex-wrap gap-1.5">
        {SUGGESTIONS.filter((s) => !list.some((e) => e.title === s)).map((s) => (
          <button key={s} onClick={() => add(s)} className="text-xs font-semibold px-2.5 py-1.5 rounded-full border border-slate-200 text-slate-600 hover:border-blue-300">+ {s}</button>
        ))}
      </div>

      <button onClick={() => add()} data-testid="add-extra" className="mt-3 w-full inline-flex items-center justify-center gap-2 border-2 border-dashed border-slate-200 rounded-xl py-2.5 text-sm font-semibold text-slate-500 hover:border-blue-400 hover:text-blue-600"><Plus className="w-4 h-4" /> Aggiungi servizio</button>
    </div>
  );
}
